import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Service from './utils/request'
import {md5} from './utils/crypto'
import * as echarts from 'echarts';
import {format} from 'date-fns'
// 自定义主题引入
import './theme/index.css'
import common from './common/index'
import vueSeamlessScroll from 'vue-seamless-scroll';




Vue.config.productionTip = false
Vue.prototype.$request = Service
Vue.prototype.$md5 = md5
Vue.prototype.$echarts = echarts;
Vue.prototype.$format = format;
Vue.prototype.$api = common

Vue.use(ElementUI)
Vue.use(vueSeamlessScroll)

Vue.config.devtools = true

const app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

export default app
